import { useAuthStore } from '@/stores/auth'
import { getAuthStatus } from '@/lib/auth-utils'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { RefreshCw, Eye, EyeOff } from 'lucide-react'
import { useState } from 'react'

export function DebugAuth() {
  const { user, isAuthenticated, token, isLoading } = useAuthStore()
  const [isVisible, setIsVisible] = useState(false)
  const authStatus = getAuthStatus()

  if (!import.meta.env.DEV) return null

  const handleRefresh = () => {
    window.location.reload()
  }

  if (!isVisible) {
    return (
      <div className="fixed bottom-4 left-4 z-50">
        <Button
          variant="outline"
          size="sm"
          onClick={() => setIsVisible(true)}
          className="bg-warning/10 border-warning/40 text-warning"
        >
          <Eye className="w-3 h-3 mr-1" />
          Debug
        </Button>
      </div>
    )
  }

  return (
    <div className="fixed bottom-4 left-4 z-50 max-w-sm">
      <Card className="border-warning/40 bg-warning/10">
        <CardHeader className="pb-2">
          <div className="flex items-center justify-between">
            <CardTitle className="text-sm text-warning">Debug Auth</CardTitle>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsVisible(false)}
            >
              <EyeOff className="w-3 h-3" />
            </Button>
          </div>
        </CardHeader>
        <CardContent className="space-y-3 text-xs">
          <div className="grid grid-cols-2 gap-2">
            <div>
              <span className="font-medium">Store Auth:</span>
              <Badge variant={isAuthenticated ? 'default' : 'secondary'} className="ml-1 text-xs">
                {isAuthenticated ? '是' : '否'}
              </Badge>
            </div>
            <div>
              <span className="font-medium">Utils Auth:</span>
              <Badge variant={authStatus.isAuthenticated ? 'default' : 'secondary'} className="ml-1 text-xs">
                {authStatus.isAuthenticated ? '是' : '否'}
              </Badge>
            </div>
            <div>
              <span className="font-medium">Has Token:</span>
              <Badge variant={authStatus.hasToken ? 'default' : 'secondary'} className="ml-1 text-xs">
                {authStatus.hasToken ? '是' : '否'}
              </Badge>
            </div>
            <div>
              <span className="font-medium">Auth Required:</span>
              <Badge variant={authStatus.authRequired ? 'destructive' : 'default'} className="ml-1 text-xs">
                {authStatus.authRequired ? '是' : '否'}
              </Badge>
            </div>
            <div>
              <span className="font-medium">Loading:</span>
              <Badge variant={isLoading ? 'default' : 'secondary'} className="ml-1 text-xs">
                {isLoading ? '是' : '否'}
              </Badge>
            </div>
            <div>
              <span className="font-medium">Dev Mode:</span>
              <Badge variant={authStatus.isDev ? 'default' : 'secondary'} className="ml-1 text-xs">
                {authStatus.isDev ? '是' : '否'}
              </Badge>
            </div>
          </div>

          {user && (
            <div className="pt-2 border-t border-warning/30">
              <div className="space-y-1">
                <p><strong>用戶:</strong> {user.firstName} {user.lastName}</p>
                <p><strong>用戶名:</strong> @{user.username}</p>
                <p><strong>角色:</strong> {user.role}</p>
                <p><strong>TG ID:</strong> {user.telegramId}</p>
              </div>
            </div>
          )}

          {token && (
            <div className="pt-2 border-t border-warning/30">
              <p><strong>Token:</strong> {token.substring(0, 20)}...</p>
            </div>
          )}

          <div className="pt-2 border-t border-warning/30">
            <p><strong>LocalStorage Token:</strong></p>
            <p className="break-all">
              {typeof window !== 'undefined' ? 
                (localStorage.getItem('access_token')?.substring(0, 30) + '...') || '無' : 
                '無'}
            </p>
          </div>

          <Button 
            variant="outline" 
            size="sm" 
            onClick={handleRefresh}
            className="w-full"
          >
            <RefreshCw className="w-3 h-3 mr-1" />
            重新加載
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}